import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { Page } from '../components';
import { reactPlugin } from "../AppInsights";
import { ObjectCreator } from '../features/ObjectCreator/ObjectCreator'
import React from "react";
import { Block } from "baseui/block";

const ObjectsCreate = () => {

    return (
        <Block height={'85vh'} display={'flex'} flexDirection='column'  >
            <Page header='App Creator' subheader='Add new Apps here'>
                <ObjectCreator></ObjectCreator>
            </Page>
        </Block>
    )
}


export default React.memo(withAITracking(reactPlugin, ObjectsCreate));